import { render } from "./dashboard.vue?vue&type=template&id=753135dc"
import script from "./dashboard.vue?vue&type=script&lang=ts"
export * from "./dashboard.vue?vue&type=script&lang=ts"
script.render = render

export default script